<template>
  <div class="school-pass-manager">
    <!-- Шапка с управлением -->
    <div class="pass-manager-header">
      <v-btn color="error" @click="$emit('close')" small>
        <v-icon left>mdi-close</v-icon>
        Закрыть
      </v-btn>

      <div class="header-actions">
        <v-btn
          color="primary"
          @click="createPassForAll"
          :disabled="loading || !selectedStudents.length"
        >
          <v-icon left>mdi-card-plus</v-icon>
          Создать всем выбранным
        </v-btn>

        <v-btn
          color="warning"
          @click="deletePassForAll"
          :disabled="loading || !selectedStudents.length"
        >
          <v-icon left>mdi-card-remove</v-icon>
          Удалить у выбранных
        </v-btn>

        <v-btn
          color="success"
          @click="printPass = !printPass"
          :disabled="!selectedStudents.length"
        >
          <v-icon left>mdi-printer</v-icon>
          Печать выбранных
        </v-btn>
      </div>
    </div>

    <!-- Фильтры и поиск -->
    <div class="filters">
      <!-- <v-text-field
        v-model="search"
        label="Поиск по имени"
        prepend-icon="mdi-magnify"
        dense
        outlined
        clearable
      ></v-text-field> -->

      <v-select
        v-model="passFilter"
        :items="filterOptions"
        label="Фильтр по пропускам"
        dense
        outlined
        clearable
      ></v-select>
    </div>

    <v-btn color="secondary" @click="selectAll" small>
      {{ allSelected ? "Снять все" : "Выбрать всех" }}
    </v-btn>
    <!-- Таблица студентов -->
    <div class="students-table">
      <v-text-field
        v-model="search"
        label="Поиск"
        prepend-inner-icon="mdi-magnify"
        clearable
        dense
        outlined
        class="mb-4"
      ></v-text-field>
      <v-data-table
        v-model="selectedStudents"
        :headers="headers"
        :items="filteredStudents"
        :loading="loading"
        show-select
        item-key="_id"
        :items-per-page="10"
        class="elevation-1"
      >
        <!-- Колонка с именем -->
        <template v-slot:item.fullName="{ item }">
          <div class="student-name">
            <strong>
              {{ item.FirstName || item.username }} {{ item.LastName }}</strong
            >
            <div class="student-class" v-if="item.classID">
              Класс: {{ item.classID }}
            </div>
          </div>
        </template>

        <!-- Колонка с статусом пропуска -->
        <template v-slot:item.passStatus="{ item }">
          <div class="pass-status">
            <v-chip v-if="item.schoolPass" small color="success">
              <v-icon left small>mdi-check</v-icon>
              Есть пропуск
            </v-chip>
            <v-chip v-else small color="error">
              <v-icon left small>mdi-close</v-icon>
              Нет пропуска
            </v-chip>
          </div>
        </template>

        <!-- Колонка с действиями -->
        <template v-slot:item.actions="{ item }">
          <div class="action-buttons">
            <v-btn
              v-if="!item.schoolPass"
              color="primary"
              small
              @click="createPassForStudent(item)"
              :loading="item.creatingPass"
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              v-if="item.schoolPass"
              color="error"
              small
              @click="deletePassForStudent(item)"
              :loading="item.deletingPass"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>

            <v-btn
              v-if="item.schoolPass"
              color="info"
              small
              @click="showPassInfo(item)"
            >
              <v-icon small>mdi-information</v-icon>
            </v-btn>
          </div>
        </template>

        <!-- Колонка с QR кодом -->
        <template v-slot:item.qrCode="{ item }">
          <div v-if="item.schoolPass" class="qr-preview" style="margin: 5px">
            <VueQRCodeComponent
              :text="item.schoolPass._id"
              :size="80"
              color="#000000"
              bg-color="#ffffff"
              error-level="L"
            ></VueQRCodeComponent>
          </div>
          <span v-else class="text-muted">—</span>
        </template>
      </v-data-table>
    </div>

    <!-- Модалка с информацией о пропуске -->
    <v-dialog v-model="showPassDialog" max-width="500">
      <v-card v-if="selectedPass">
        <v-card-title class="headline"> Информация о пропуске </v-card-title>

        <v-card-text>
          <div class="pass-info">
            <div><strong>Владелец:</strong> {{ selectedPass.studentName }}</div>
            <div><strong>ID пропуска:</strong> {{ selectedPass.passId }}</div>
            <div>
              <strong>Создан:</strong> {{ formatDate(selectedPass.createdAt) }}
            </div>
            <div v-if="selectedPass.expiresAt">
              <strong>Действует до:</strong>
              {{ formatDate(selectedPass.expiresAt) }}
            </div>
            <div>
              <strong>Статус:</strong>
              {{
                selectedPass.type === "temporary" ? "Временный" : "Постоянный"
              }}
            </div>

            <div style="overflow-y: auto; max-height: 150px">
              <ul>
                <li v-for="use in selectedPass.useHistory" :key="use">
                  {{ new Date(use).toLocaleDateString() }}
                  {{ new Date(use).toLocaleTimeString() }}
                </li>
              </ul>
            </div>
          </div>

          <div class="qr-large">
            <VueQRCodeComponent
              :text="selectedPass.passId"
              :size="200"
              color="#000000"
              bg-color="#ffffff"
              error-level="L"
            ></VueQRCodeComponent>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            @click="deletePassForStudent(selectedPass.student)"
          >
            Удалить
          </v-btn>
          <v-btn text @click="showPassDialog = false"> Закрыть </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="printPass" width="90%" height="95%">
      <div style="background-color: white">
        <v-btn
          color="success"
          @click="printPasses"
          :disabled="!selectedStudents.length"
        >
          <v-icon left>mdi-printer</v-icon>
          Печать выбранных
        </v-btn>
        <div>Лучше печатать в масштабе 160% партиями</div>
        <div id="tablePrint">
          <div style="display: flex; flex-wrap: wrap; width: 100%">
            <div
              style="
                border: 1px solid black;
                min-width: 200px;
                max-width: 200px;
                margin: 5px;
                display: flex;
              "
              id="tablePrint"
              v-for="item in selectedStudents"
              :key="item"
            >
              <div style="flex: 1; margin: 5px; line-height: 10px">
                <div style="font-size: 10px">
                  {{ item.FirstName || item.username }}
                  {{ item.LastName || "" }}
                </div>
                <div style="font-size: 6px" v-if="item.schoolPass">
                  {{ getRole(item.schoolPass.role) }}
                </div>
                <div style="font-size: 8px">
                  МБОУ СОШ №24 имени генерала <br />Н.Н. Раевского
                </div>
                <div style="text-align: center">
                  <img
                    src="https://brend.actsch24.ru/img/%D0%9B%D0%BE%D0%B3%D0%BE%D1%82%D0%B8%D0%BF%20%D0%9C%D0%91%D0%9E%D0%A3%20%D0%A1%D0%9E%D0%A8%20%E2%84%9624%20%D0%B8%D0%BC%D0%B5%D0%BD%D0%B8%20%D0%B3%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D0%BB%D0%B0%20%D0%9D.%D0%9D.%20%D0%A0%D0%B0%D0%B5%D0%B2%D1%81%D0%BA%D0%BE%D0%B3%D0%BE.png"
                    alt=""
                    width="32px"
                  />
                </div>
              </div>

              <div v-if="item.schoolPass" style="margin: 10px; flex: 1">
                <VueQRCodeComponent
                  :text="item.schoolPass._id"
                  :size="90"
                  color="#000000"
                  bg-color="#ffffff"
                  error-level="L"
                ></VueQRCodeComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>

    <!-- Скрытый контейнер для печати -->
    <div v-if="false" id="printContainer"></div>
  </div>
</template>

<script>
import Vue from "vue"; // ← Добавь эту строку
import VueQRCodeComponent from "vue-qrcode-component";
//import TutorialDataService from "../services/TutorialDataService";
import SchoolPassService from "../../services/SchoolPassService";

export default {
  name: "SchoolPassManager",
  components: {
    VueQRCodeComponent,
  },
  props: {
    students: {
      type: Array,
      required: true,
      default: () => [],
    },
    dbName: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      search: "",
      passFilter: null,
      printPass: false,
      filterOptions: [
        { text: "Только с пропусками", value: "hasPass" },
        { text: "Без пропусков", value: "noPass" },
        { text: "Только временные", value: "temporary" },
        { text: "Только постоянные", value: "permanent" },
      ],
      selectedStudents: [],
      headers: [
        { text: "Выбрать", value: "data-table-select", sortable: false },
        { text: "ФИО", value: "fullName" },
        { text: "Статус пропуска", value: "passStatus", sortable: false },
        { text: "QR код", value: "qrCode", sortable: false, align: "center" },
        {
          text: "Действия",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      showPassDialog: false,
      selectedPass: null,
      studentsWithPasses: [],
    };
  },
  computed: {
    filteredStudents() {
      let filtered = [...this.studentsWithPasses];

      // Фильтр по поиску
      if (this.search && this.search.trim()) {
        const searchLower = this.search.toLowerCase().trim();
        filtered = filtered.filter((student) => {
          const fullName = `${student.FirstName || ""} ${
            student.LastName || ""
          } ${student.username || ""}`.toLowerCase();
          return fullName.includes(searchLower);
        });
      }

      // Фильтр по статусу пропуска
      if (this.passFilter === "hasPass") {
        filtered = filtered.filter((s) => s.schoolPass);
      } else if (this.passFilter === "noPass") {
        filtered = filtered.filter((s) => !s.schoolPass);
      } else if (this.passFilter === "temporary") {
        filtered = filtered.filter((s) => s.schoolPass?.type === "temporary");
      } else if (this.passFilter === "permanent") {
        filtered = filtered.filter((s) => s.schoolPass?.type === "permanent");
      }

      return filtered;
    },
    allSelected() {
      return (
        this.selectedStudents.length === this.filteredStudents.length &&
        this.filteredStudents.length > 0
      );
    },
  },
  watch: {
    students: {
      immediate: true,
      handler(newStudents) {
        this.loadPassesForStudents(newStudents);
      },
    },
  },
  methods: {
    async loadPassesForStudents(students) {
      this.loading = true;
      try {
        const userIds = students.map((s) => s._id);

        // Загружаем пропуска для всех студентов
        const response = await SchoolPassService.getPassesByUserIDs({
          userIds,
          dbName: this.dbName,
        });

        const passes = response.data.data || [];

        // Сопоставляем студентов с их пропусками
        this.studentsWithPasses = students.map((student) => {
          const studentPass = passes.find(
            (pass) => pass.userID === student._id,
          );
          return {
            ...student,
            schoolPass: studentPass || null,
            creatingPass: false,
            deletingPass: false,
          };
        });
      } catch (error) {
        console.error("Ошибка загрузки пропусков:", error);
        this.$emit("error", "Не удалось загрузить информацию о пропусках");
      } finally {
        this.loading = false;
      }
    },

    async createPassForStudent(student) {
      this.$set(student, "creatingPass", true);
      try {
        const passData = {
          userID: student._id,
          name: `${this.className} ${
            student.LastName ? student.LastName : student.username
          } ${student.FirstName ? student.FirstName : ""} `.trim(),
          role: student.role ? student.role : "student",
          type: "permanent", // По умолчанию постоянный
          uniqueQR:
            `${student.role ? student.role : "student"}` +
            `_${student._id}_${Date.now()}`,
        };

        const response = await SchoolPassService.createSchoolPass({
          ...passData,
          dbName: this.dbName,
        });

        // Обновляем данные студента
        student.schoolPass = response.data.data;
        this.$emit("pass-created", { student, pass: response.data.data });

        this.$toast.success(`Пропуск для ${student.FirstName} создан`);
      } catch (error) {
        console.error("Ошибка создания пропуска:", error);
        this.$toast.error(`Ошибка создания пропуска: ${error.message}`);
      } finally {
        this.$set(student, "creatingPass", false);
      }
    },

    async deletePassForStudent(student) {
      if (!student.schoolPass) return;

      console.log(student);
      if (!confirm(`Удалить пропуск у ${student.schoolPass.name}?`)) {
        return;
      }

      this.$set(student, "deletingPass", true);
      try {
        await SchoolPassService.deletePassByID({
          id: student.schoolPass._id,
          dbName: this.dbName,
        });

        // Обновляем данные студента
        student.schoolPass = null;
        this.$emit("pass-deleted", { student });

        this.$toast.success(`Пропуск у ${student.FirstName} удален`);
      } catch (error) {
        console.error("Ошибка удаления пропуска:", error);
        this.$toast.error(`Ошибка удаления пропуска: ${error.message}`);
      } finally {
        this.$set(student, "deletingPass", false);
      }
    },

    async createPassForAll() {
      if (!this.selectedStudents.length) return;

      if (
        !confirm(
          `Создать пропуска для ${this.selectedStudents.length} учеников?`,
        )
      ) {
        return;
      }

      this.loading = true;
      try {
        const promises = this.selectedStudents
          .filter((s) => !s.schoolPass)
          .map((student) => this.createPassForStudent(student));

        await Promise.all(promises);
        this.$toast.success(`Пропуска созданы для ${promises.length} учеников`);
      } catch (error) {
        console.error("Ошибка массового создания:", error);
      } finally {
        this.loading = false;
      }
    },

    async deletePassForAll() {
      if (!this.selectedStudents.length) return;

      const count = this.selectedStudents.filter((s) => s.schoolPass).length;
      if (!count) {
        this.$toast.warning("У выбранных учеников нет пропусков");
        return;
      }

      if (!confirm(`Удалить пропуска у ${count} учеников?`)) {
        return;
      }

      this.loading = true;
      try {
        const promises = this.selectedStudents
          .filter((s) => s.schoolPass)
          .map((student) => this.deletePassForStudent(student));

        await Promise.all(promises);
        this.$toast.success(`Пропуска удалены у ${count} учеников`);
      } catch (error) {
        console.error("Ошибка массового удаления:", error);
      } finally {
        this.loading = false;
      }
    },

    showPassInfo(student) {
      if (!student.schoolPass) return;

      this.selectedPass = {
        student,
        studentName: student.schoolPass.name,
        passId: student.schoolPass._id,
        createdAt: student.schoolPass.createdAt,
        expiresAt: student.schoolPass.expiresAt,
        type: student.schoolPass.type,
        useHistory: student.schoolPass.useHistory,
      };
      this.showPassDialog = true;
    },

    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleString("ru-RU");
    },

    selectAll() {
      if (this.allSelected) {
        this.selectedStudents = [];
      } else {
        this.selectedStudents = [...this.filteredStudents];
      }
    },
    async printSinglePass(student) {
      if (!student.schoolPass) return;

      try {
        // Генерируем QR код
        const qrData = await this.generateQRCode(student.schoolPass._id, 150);

        // Создаем HTML для печати
        const html = `
          <!DOCTYPE html>
          <html>
          <head>
            <title>Пропуск</title>
            <style>
              @page { margin: 0; }
              body {
                margin: 0;
                padding: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 100vh;
                font-family: Arial, sans-serif;
              }
              .card {
                width: 85mm;
                height: 54mm;
                border: 2px solid #000;
                text-align: center;
                padding: 10px;
                box-sizing: border-box;
              }
              .name {
                font-size: 16px;
                font-weight: bold;
                margin: 10px 0;
                line-height: 1.2;
              }
              .qr img {
                width: 120px;
                height: 120px;
                margin: 10px 0;
              }
              .id {
                font-size: 10px;
                color: #666;
                margin-top: 5px;
              }
            </style>
          </head>
          <body>
            <div class="card">
              <div class="name">${student.LastName}<br>${
          student.FirstName
        }</div>
              <div class="qr"><img src="${qrData}"></div>
              <div class="id">ID: ${student.schoolPass._id.substring(
                0,
                12,
              )}</div>
            </div>
          </body>
          </html>
        `;

        // Печатаем
        this.printHTML(html);
      } catch (error) {
        console.error("Ошибка печати:", error);
        alert("Ошибка при печати пропуска");
      }
    },

    async printPasses() {
      //  let printHtml = document.getElementById("table").innerHTML; // Получаем содержимое узла для печати

      let tab = window.open(
        "",
        "",
        "left=50,top=50,width=800,height=640,toolbar=0,scrollbars=1,status=0",
      );
      tab.document.write(
        document.getElementById("tablePrint").innerHTML +
          "<style>table, td, th {border: 1px solid#ddd;text-align: left;}table {border-collapse: collapse;width: 100%;}th, td {padding: 15px;}</style>",
      );
      // tab.document.close();
      tab.focus();
    },

    getRole(role) {
      if (role == "student") {
        return "Ученик";
      }
      if (role == "employee") {
        return "Сотрудник";
      }
      if (role == "teacher") {
        return "Учитель";
      }
      if (role == "admin") {
        return "Администратор";
      }
      if (role == "parent_comitet") {
        return "Родительский комитет";
      }
      if (role == "parent_special") {
        return "Родитель (специальный)";
      }
      if (role == "parent") {
        return "Родитель";
      }
      return "";
    },

    // Функция генерации QR кода
    generateQRCode(text, size) {
      return new Promise((resolve) => {
        // Создаем временный контейнер
        const container = document.createElement("div");
        document.body.appendChild(container);

        // Создаем Vue инстанс
        const QRComponent =
          Vue.component("VueQRCodeComponent") ||
          this.$options.components.VueQRCodeComponent;

        new Vue({
          el: container,
          render: (h) =>
            h(QRComponent, {
              props: {
                text: text,
                size: size,
                color: "#000000",
                "bg-color": "#ffffff",
                "error-level": "L",
              },
            }),
          mounted() {
            // Ждем следующего тика
            this.$nextTick(() => {
              const svg = this.$el.querySelector("svg");
              if (svg) {
                const svgString = new XMLSerializer().serializeToString(svg);
                const svgData =
                  "data:image/svg+xml;base64," +
                  btoa(unescape(encodeURIComponent(svgString)));
                resolve(svgData);
              } else {
                // Fallback на Canvas
                const canvas = document.createElement("canvas");
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext("2d");
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, size, size);
                ctx.fillStyle = "#000";
                ctx.font = "14px Arial";
                ctx.textAlign = "center";
                ctx.fillText("QR: " + text.substring(0, 8), size / 2, size / 2);
                resolve(canvas.toDataURL());
              }

              // Удаляем контейнер
              document.body.removeChild(container);
              this.$destroy();
            });
          },
        });
      });
    },

    // Общая функция для печати HTML
    printHTML(html) {
      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        alert("Разрешите всплывающие окна для печати");
        return;
      }

      printWindow.document.write(html);
      printWindow.document.close();

      // Ждем загрузки изображений
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 500);
      };
    },

    // Вспомогательная функция для экранирования HTML
    escapeHtml(text) {
      if (!text) return "";
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    },
    generatePassHTML(students) {
      return `
        <style>
          @media print {
            body * {
              visibility: hidden;
            }
            #printContainer, #printContainer * {
              visibility: visible;
            }
            #printContainer {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }

          .pass-print-page {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            padding: 20px;
            page-break-after: always;
          }

          .pass-card {
            width: 85mm;
            height: 54mm;
            border: 2px solid #000;
            border-radius: 10px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            page-break-inside: avoid;
            margin-bottom: 10px;
          }

          .pass-header {
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 5px;
          }

          .student-info {
            text-align: center;
            font-size: 12px;
            margin-bottom: 10px;
          }

          .qr-container {
            text-align: center;
          }

          .pass-id {
            font-size: 10px;
            color: #666;
            margin-top: 5px;
          }

          .school-logo {
            font-size: 16px;
            font-weight: bold;
            color: #1976d2;
            margin-top: 5px;
          }
        </style>

        <div class="pass-print-page">
          ${students
            .map(
              (student) => `
            <div class="pass-card">
              <div class="pass-header">ШКОЛЬНЫЙ ПРОПУСК</div>
              <div class="student-info">
                <div><strong>${student.LastName} ${
                student.FirstName
              }</strong></div>
                ${student.classID ? `<div>Класс: ${student.classID}</div>` : ""}
                ${
                  student.schoolPass?.createdAt
                    ? `
                  <div>Выдан: ${new Date(
                    student.schoolPass.createdAt,
                  ).toLocaleDateString("ru-RU")}</div>
                `
                    : ""
                }
              </div>
              <div class="qr-container">
                <img src="${this.generateQRCodeImage(
                  student.schoolPass._id,
                  120,
                )}"
                     alt="QR Code"
                     style="width: 120px; height: 120px;">
              </div>
              <div class="pass-id">ID: ${student.schoolPass._id.substring(
                0,
                8,
              )}...</div>
              <div class="school-logo">${this.dbName || "ШКОЛА"}</div>
            </div>
          `,
            )
            .join("")}
        </div>
      `;
    },

    generateQRCodeImage(text, size) {
      // Здесь можно использовать библиотеку для генерации QR кода в base64
      // Для простоты возвращаем placeholder
      return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(
        text,
      )}`;
    },
  },
};
</script>

<style scoped>
.school-pass-manager {
  padding: 20px;
}

.pass-manager-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.filters > * {
  flex: 1;
}

.students-table {
  margin-top: 20px;
}

.student-name {
  display: flex;
  flex-direction: column;
}

.student-class {
  font-size: 12px;
  color: #666;
}

.pass-status {
  display: flex;
  justify-content: center;
}

.action-buttons {
  display: flex;
  gap: 5px;
  justify-content: center;
}

.qr-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-hint {
  font-size: 10px;
  color: #666;
  margin-top: 5px;
}

.pass-info {
  margin-bottom: 20px;
}

.pass-info > div {
  margin-bottom: 10px;
}

.qr-large {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
